import { useQuery } from '@apollo/client';

import user from 'js/lib/user';

import type {
  DegreeMembershipsQuery as DegreeMembershipsQueryData,
  DegreeMembershipsQueryVariables,
} from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/degreeLearnerMembershipsV1Resource';
import DegreeLearnerMembershipsQuery from 'bundles/degree-home/components/v3-dpm/lib/__queries__/degreeLearnerMembershipsV1Resource.graphql';

export const useDegreeLearnerMemberships = () => {
  const userId = user.get()?.id?.toString() ?? '';

  const variables: DegreeMembershipsQueryVariables = {
    userId,
  };

  return useQuery<DegreeMembershipsQueryData, DegreeMembershipsQueryVariables>(DegreeLearnerMembershipsQuery, {
    variables,
    context: { clientName: 'gatewayGql' },
  });
};

export default useDegreeLearnerMemberships;
